import { PORTAL_APP_STATE } from '~/libs/portal-constants'

export const USER_VIEW_CONSTANTS = {
    QUALIFIED: 'QUALIFIED',
    UNQUALIFIED: 'UNQUALIFIED',
    WITH_OFFERS: 'WITH_OFFERS',
    WITH_ACTIVE_DEAL: 'WITH_ACTIVE_DEAL',
    WITH_FUNDED_DEAL: 'WITH_FUNDED_DEAL',
}

export const BORROWER_OPTIONS = {
    ADD_OFFER: 'ADD_OFFER',
    ADD_FUNDED_DEAL: 'ADD_FUNDED_DEAL'
}

export const overrideOptions = [
    {
        optionType: USER_VIEW_CONSTANTS.QUALIFIED,
        displayTitle: 'Qualified',
    },
    {
        optionType: USER_VIEW_CONSTANTS.UNQUALIFIED,
        displayTitle: 'Unqualified',
    },
]

export const overrideMarketplace = [
    {
        optionValue: false,
        displayTitle: 'Marketplace',
    },
]

export const applicationStates = [
    {
        appStateValue: PORTAL_APP_STATE.INCOMPLETE,
        displayTitle: 'Incomplete'
    },
    {
        appStateValue: PORTAL_APP_STATE.COMPLETE,
        displayTitle: 'Complete'
    },
    {
        appStateValue: PORTAL_APP_STATE.LENDER_DOCS,
        displayTitle: 'Needs Lender Docs'
    },
    {
        appStateValue: PORTAL_APP_STATE.BANK_DOCS,
        displayTitle: 'Needs Bank Docs'
    },
]

export const DEAL_STAGES = {
    APPLICATION: 'application',
    UNDERWRITING: 'underwriting',
    CLOSING: 'closing',
    FUNDED: 'funded',
    INACTIVE: 'inactive',
}

export const DEAL_STATUSES_BY_STAGE = {
    [DEAL_STAGES.APPLICATION]: {
        APP_IN_PROGRESS: 'appInProgress',
        APP_COMPLETE: 'appComplete',
    },
    [DEAL_STAGES.UNDERWRITING]: {
        AWAITING_RESPONSE: 'awaitingResponse',
        PENDING_FM: 'pendingFundingManager',
        DECLINED: 'declined',
        OFFER_DECLINED: 'offerDeclined',
        OFFER_RECEIVED: 'offerReceived',
        OFFER_TO_BORROWER: 'offerToBorrower',
        OFFER_ACCEPTED: 'offerAccepted',
    },
    [DEAL_STAGES.CLOSING]: {
        CONTRACT_REQUESTED: 'contractRequested',
        CONTRACT_OUT: 'contractOut',
        CONTRACT_IN: 'contractIn',
        FUNDING: 'funding',
    },
    [DEAL_STAGES.FUNDED]: {
        CURRENT: 'current',
        RENEWED: 'renewed',
        BEHIND: 'behind',
        DEFAULT: 'default',
        PAID_OFF: 'paidOff',
        STACKED: 'stacked',
    },
    [DEAL_STAGES.INACTIVE]: {
        LOST_CONTACT: 'lostContact',
        DOES_NOT_QUALIFY: 'doesNotQualify',
        DEAD: 'dead',
    },
}

export const testDeal = {
    acceptedOffer: undefined,
    applications: [],
    autoSubmitType: null,
    categoryShortName: "ACH",
    created: "2021-07-30 14:33:21",
    dateClosed: null,
    deleted: null,
    documents: [],
    lastActivity: {},
    lenderDomain: null,
    lenderId: 45972,
    lenderName: "Marshmello Funding - Fake",
    loanProductCategoryType: "ach",
    loanProductId: 395,
    loanType: "ACH Cashflow Loan",
    maxOffer: 0,
    offers: [],
    progress: {
        status: "awaitingOffers",
        step: "application",
    },
    sbaLoanNumber: null,
    type: "new",
}

export const testOffer = {
    amount: "15000.00",
    apr: "10.0000",
    commission: "500.00",
    created: "2021-07-30 15:13:01",
    id: 1173151,
    lenderName: "Marshmello Funding - Fake",
    loanProductType: "ach",
    name: "Offer 1",
    payback: "20000.00",
    paymentAmount: "500.00",
    paymentFrequency: "monthly",
    paymentTerm: null,
    term: 60,
}

export function testDealWithOffer(payload) {
    const { stage, status } = payload
    const dealId = Math.floor(Math.random() * 10000)
    const offerId = Math.floor(Math.random() * 10000)
    const dealCopy = JSON.parse(JSON.stringify(testDeal))
    dealCopy.id = dealId
    dealCopy.stage = stage
    dealCopy.status = status
    const offerCopy = JSON.parse(JSON.stringify(testOffer))
    offerCopy.id = offerId
    offerCopy.dealId = dealId
    dealCopy.maxOffer = offerCopy.amount
    dealCopy.offers.push(offerCopy)
    return dealCopy
}

export default {
  USER_VIEW_CONSTANTS,
  BORROWER_OPTIONS,
  overrideOptions,
  overrideMarketplace,
  applicationStates,
  DEAL_STAGES,
  DEAL_STATUSES_BY_STAGE,
  testDeal,
  testOffer,
  testDealWithOffer,
}
